import React, { FunctionComponent } from 'react';
import Asset from 'src/requests/apa/Asset';

interface ITeam {
    teamAbbreviation: string,
    teamName: string,
    logo: string
}

interface ITeamProps{
    teamData: ITeam,
    scrollFocus: any
}


export const Team: FunctionComponent<ITeamProps> = (props) => {
    const { teamData, scrollFocus } = props;
        return(
            <div className='cont-team'>
                <div className='box-img'>
                    <img className='img-focusable' src={teamData.logo ? teamData.logo : Asset.get("vcard_team_placeholder_img", "")} alt="" />
                </div>
                <div className='name'>
                    <a href='' data-sn-left='' id='team-name' className='focusable' target='_blank' 
                        onClick={(e) => e.preventDefault()}
                        onFocus={scrollFocus}
                    >
                        <span>{teamData.teamName}</span>
                    </a>
                </div>
                <div className='team'>{teamData.teamAbbreviation}</div>
            </div>
        )
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardTeam/team.tsx